import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enquiries-jobs-listing',
  templateUrl: './enquiries-jobs-listing.component.html',
  styleUrls: ['./enquiries-jobs-listing.component.scss']
})
export class EnquiriesJobsListingComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router) { }
  loginDetails: any;
  myEnquiryAllList: any;
  // myEnquiryJob: any;
  openEnquiryAccordionId: string | null = null;
  enquiryData: any[];
  newMessage: string = '';
  openAccordionId: string | null = null;
  displayMessage: any[] = [];
  EditedMessageId: string = '';

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreEnquiries();


  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }


  limit = 5;
  offset = 0;
  loading = false;
  endOfData = false;

  myEnquiryJob: any[] = [];

  loadMoreEnquiries(): void {

    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.jobService.getMyEnquiryJobs(this.limit, this.offset).subscribe({
      next: (jobs) => {

        const enrichedJobs = jobs;

        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.myEnquiryJob = [...this.myEnquiryJob, ...enrichedJobs];
        this.offset += this.limit;
        this.loading = false;

      },
      error: (err) => {
        console.error("Error fetching enquiry jobs:", err);
        this.loading = false;
      }
    });


  }

  // Enquiry
  EnquiryAcoordion(jobs: any): void {
    // Close the message accordion when opening the enquiry accordion
    this.openAccordionId = null;
    this.enquiryData = [];

    this.openEnquiryAccordionId = this.openEnquiryAccordionId === jobs.id ? null : jobs.id;

    const jobID = jobs?.job_id;
    const userId = jobs?.enquiry_userid;

    this.jobService.getApplicantEnquiry(jobID, userId).subscribe((data) => {
      this.enquiryData = data;
    });

  }

  messageAcordion(job: any): void {
    // Close the enquiry accordion when opening the message accordion
    this.openEnquiryAccordionId = null;

    this.openAccordionId = this.openAccordionId === job.id ? null : job.id;
    this.newMessage = '';
    // Clear messages first
    this.displayMessage = [];


    this.getAllMessage(job?.job_applicants_find?.id, job?.id);

  }


  getAllMessage(ApplicantId: any, EnquiryId: any) {

    this.jobService
      .getApplicantMessage(ApplicantId, EnquiryId)
      .subscribe((data) => {
        this.displayMessage = data;
      });
  }



  // send message

  sendMessage(jobId: any): void {

    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Applied Job Message
    const messages = {
      message: this.newMessage,
      message_from: this.loginDetails.id,
      job_enquiry_id: jobId.id
    };

    this.jobService.addApplicantMessage(messages);

    this.newMessage = ''; // Clear the input box
  }


  deleteMessage(messageId: string): void {

    this.jobService.deleteApplicantMessage(messageId).then(() => {

    }).catch((err) => {
      console.error("Error deleting message:", err);
    })
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {

    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
    }

    this.jobService.editApplicantMessages(UpdateMessage.id, UpdateMessage.message).then(() => {
      this.EditedMessageId = '';
      this.newMessage = '';
    })

  }

  trackByJobId(index: number, job: any): string {

    return job.id;
  }

}
